/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Return1Inputs */

const vi_sitesettings_icon_return1 = /** @type {(inputs: Sitesettings_Icon_Return1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi trả`)
};

/**

* @param {Sitesettings_Icon_Return1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_return1 = /** @type {((inputs?: Sitesettings_Icon_Return1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Return1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_return1(inputs)
});
export { sitesettings_icon_return1 as "siteSettings_icon_return" }